import script from "./InputPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./InputPhone.vue?vue&type=script&setup=true&lang=js"

import "./InputPhone.vue?vue&type=style&index=0&id=c3fc3378&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3fc3378"]])

export default __exports__